import React, { Component } from 'react';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: this.props.popup && this.props.popup.enable
    }
  }

  closeModal(e){
    e.preventDefault()
    this.setState({
      modalOpen: false
    })
  }
  render() {
    return (
      <div className="">
        <h1>&nbsp;</h1>

        <div className="row">
          { this.props.disableCoffee ? null : (
            <div className="col-xs-6">
              <p>
                <a href="#/coffee" className="btn btn-block btn-lg btn-warning" >
                  Order Coffee
                </a>
              </p>
              <p>Order coffee to be made on demand</p>
              <p>
                Currently only available at PNGHS - please check back soon for
                other schools
              </p>
              <p>
                <strong>Students:</strong> Please ensure you only order coffees during break times.
                Coffee will not be served to students outside of break times.
              </p>
            </div>
          )}
          { this.props.disableLunch ? null : (
            <div className="col-xs-6">
              <p>
                <a href="#/lunch" className="btn btn-block btn-lg btn-primary" >
                  Order Food
                </a>
              </p>
              <p>Food orders must be made before 9:15am</p>
            </div>
          )}
          { this.props.promo && this.props.promo.enable ? (
            <div className="col-xs-6">
              <p><br /><br />
                <a className="btn btn-block btn-lg btn-primary"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfQBgHWVVF6HaoAc1Y5v8X_lFAas6TTJwZWrKpZvfDysIxN2Q/viewform?usp=sf_link">
                  {this.props.promo.text}
                </a>
              </p>
            </div>
          ) : null}
        </div>
        <div className={"warning-modal" + (this.state.modalOpen ? ' active' : '')}>
          <div className="body">
            <h1>Please note</h1>
            <br />
            <div dangerouslySetInnerHTML=
              {{__html: this.props.popup && this.props.popup.message.replace(/\n/g,'<br />')}}></div>
            <br />
            <button className="btn btn-primary" onClick={this.closeModal.bind(this)}>
              Ok
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js